import React from 'react';
var DropdownContext = React.createContext({
  onClick: function onClick(e, option) {}
});
export default DropdownContext;